import * as React from 'react';
import Header from '../Header/Header';
import DashboardButtonContainer from '../DashboardButton/DashboardButtonContainer';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import SettingsAndAccountWidget from '../SettingsAndAccountWidget/SettingsAndAccountWidget';

export default ({children, showHeaderButtons}: SkeletonPageProps) => {
   const headerLeft = showHeaderButtons && <DashboardButtonContainer/>;
   const headerMiddle = <HeaderLogo linkToRoot={false}/>;
   const headerRight = <SettingsAndAccountWidget hideSettings={!showHeaderButtons}/>;

   return (
      <div className="skeleton-page">
         <Header leftSection={headerLeft} middleSection={headerMiddle} rightSection={headerRight}/>
         {children}
      </div>
   );
};

interface SkeletonPageProps {
   children?: any;
   showHeaderButtons?: boolean;
}